/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/RawDataMappingColumn', 'model/RawDataMappingRule'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./RawDataMappingColumn'), require('./RawDataMappingRule'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.RawDataMappingReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.RawDataMappingColumn, root.ForStractionServiceApi.RawDataMappingRule);
  }
}(this, function(ApiClient, RawDataMappingColumn, RawDataMappingRule) {
  'use strict';




  /**
   * The RawDataMappingReport model module.
   * @module model/RawDataMappingReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>RawDataMappingReport</code>.
   * @alias module:model/RawDataMappingReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>RawDataMappingReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RawDataMappingReport} obj Optional instance to populate.
   * @return {module:model/RawDataMappingReport} The populated <code>RawDataMappingReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Columns')) {
        obj['Columns'] = ApiClient.convertToType(data['Columns'], [RawDataMappingColumn]);
      }
      if (data.hasOwnProperty('Rules')) {
        obj['Rules'] = ApiClient.convertToType(data['Rules'], [RawDataMappingRule]);
      }
      if (data.hasOwnProperty('SourceID')) {
        obj['SourceID'] = ApiClient.convertToType(data['SourceID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/RawDataMappingColumn>} Columns
   */
  exports.prototype['Columns'] = undefined;
  /**
   * @member {Array.<module:model/RawDataMappingRule>} Rules
   */
  exports.prototype['Rules'] = undefined;
  /**
   * @member {Integer} SourceID
   * @default 0
   */
  exports.prototype['SourceID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


